import styles from "./PostTag.module.css";

const TAG_COLORS = {
  craft: { background: "#f2e4e0", color: "#8c3a28" },
  evals: { background: "#e4ebe3", color: "#2e6040" },
  observability: { background: "#ece4ef", color: "#6b3478" },
  context: { background: "#dde8f5", color: "#1a4a7a" },
};

export default function PostTag({ tag }) {
  return (
    <span className={styles.tag} style={TAG_COLORS[tag]}>
      {tag}
    </span>
  );
}
